import { whiteboardClient as api } from "../axiosClient";

const whiteboardResource = {
	store: async (whiteboard) => {
		const response = await api.post(
			`/whiteboards`,
			{ ...whiteboard }
		);
		return response.data;
	},
	index: async ({ page, perPage, ...restQuery }) => {
		var url = `whiteboards?page=${page}&per_page=${perPage}`;
		if (restQuery) {
			for (let [query, value] of Object.entries(restQuery)) {
				url = url + `&${query}=${value}`;
			}
		}
		const response = await api.get(url);
		return response;
	},
	get: async (id) => {
		const response = await api.get(`whiteboards/${id}`);
		return response.data;
	},
	update: async (id, whiteboard) => {
		const response = await api.put(`whiteboards/${id}`, whiteboard);
		return response.data;
	},
	moveToTrash: async (id) => {
		const response = await api.delete(`whiteboards/${id}`);
		return response.data;
	},
	moveToTrashMultiple: async (ids) => {
		const response = await api.post(`whiteboards/trash`, { ids });
		return response;
	},
	restoreFromTrashMultiple: async (ids) => {
		const response = await api.post(`whiteboards/restore`, { ids });
		return response;
	},
	delete: async (id) => {
		const response = await api.delete(`whiteboards/soft/${id}`);
		return response;
	},
	deleteMultiple: async (ids) => {
		const response = await api.post(`whiteboards/softs`, { ids });
		return response;
	},
	deleteAll: async () => {
		const response = await api.post(`whiteboards/soft-all`);
		return response.data;
	},
	lock: async (ids, lock) => {
		const response = await api.post(`whiteboards/lock`, {
			ids,
			lock
		});
		return response;
	},
	//chungnm2
	copy: async (need_return_data, name, source_id) => {
		const response = await api.post(
			`/whiteboards`,
			{ need_return_data, name, source_id }
		);
		return response.data;
	},
	changeName: async (id, name) => {
		const response = await api.put(
			`/whiteboards/${id}`,
			{ name }
		);
		return response.data;
	},

	total: async () => {
		const response = await api.get(`whiteboards/get/total`);
		return response;
	},
	getWBsForSitatistics: async (page, size) => {
		const response = await api.get(`whiteboards/statistics/get-my-white-boards?page=${page}&size=${size}`);
		return response;
	}
};

export default whiteboardResource;
